import type { IconType } from 'react-icons';
import {
    PiBookOpenTextDuotone,
    PiBoatDuotone,
    PiClipboardTextDuotone,
    PiCurrencyDollarDuotone,
    PiFileTextDuotone,
    PiGlobeHemisphereWestDuotone,
    PiPackageDuotone,
    PiShieldCheckDuotone,
    PiTruckDuotone,
    PiUsersThreeDuotone,
    PiWarehouseDuotone,
} from 'react-icons/pi';

export const DOC_ICONS: { key: string; label: string; icon: IconType; tone: string }[] = [
    { key: 'overview', label: 'Visão geral', icon: PiGlobeHemisphereWestDuotone, tone: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-500/15 dark:text-indigo-300' },
    { key: 'comex', label: 'Comex / navio', icon: PiBoatDuotone, tone: 'bg-sky-50 text-sky-600 dark:bg-sky-500/15 dark:text-sky-300' },
    { key: 'warehouse', label: 'CD / armazém', icon: PiWarehouseDuotone, tone: 'bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300' },
    { key: 'stock', label: 'Estoque', icon: PiPackageDuotone, tone: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-300' },
    { key: 'truck', label: 'Logística / entrega', icon: PiTruckDuotone, tone: 'bg-orange-50 text-orange-600 dark:bg-orange-500/15 dark:text-orange-300' },
    { key: 'finance', label: 'Financeiro', icon: PiCurrencyDollarDuotone, tone: 'bg-rose-50 text-rose-600 dark:bg-rose-500/15 dark:text-rose-300' },
    { key: 'checklist', label: 'Checklist', icon: PiClipboardTextDuotone, tone: 'bg-violet-50 text-violet-600 dark:bg-violet-500/15 dark:text-violet-300' },
    { key: 'compliance', label: 'Regras / compliance', icon: PiShieldCheckDuotone, tone: 'bg-teal-50 text-teal-600 dark:bg-teal-500/15 dark:text-teal-300' },
    { key: 'people', label: 'Pessoas / RH', icon: PiUsersThreeDuotone, tone: 'bg-pink-50 text-pink-600 dark:bg-pink-500/15 dark:text-pink-300' },
    { key: 'guide', label: 'Manual', icon: PiBookOpenTextDuotone, tone: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-200' },
];

export function docIcon(key?: string | null) {
    return DOC_ICONS.find((i) => i.key === key) ?? { key: 'file', label: 'Documento', icon: PiFileTextDuotone, tone: 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-300' };
}
